import dayjs from 'dayjs';
import 'dayjs/locale/uk';

dayjs.locale('uk');

export const getWeekStartDate = (value) => {
  const date = value ? dayjs(value) : dayjs();
  const diffToMonday = (date.day() + 6) % 7;
  return date.subtract(diffToMonday, 'day').startOf('day');
};

export const formatWeekRangeLabel = (value) => {
  const start = getWeekStartDate(value);
  const end = start.add(6, 'day');
  const startLabel = start.format('DD MMM');
  const endLabel = end.format(start.month() === end.month() ? 'DD MMM YYYY' : 'DD MMM YYYY');
  return `${startLabel} – ${endLabel}`;
};

export const WEEKDAY_LABELS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];



